export const ROUTES = {
    HOME: "/",
    FAMILY_GALLERY: "/gallery/family",
    CHILDREN_GALLERY: "/gallery/children",
    FOOD_PRODUCT_GALLERY: "/gallery/food-product",
    PLACES_SPACES_GALLERY: "/gallery/places-spaces",
    ABOUT: "/about",
    CONTACT: "/contact",
};
